import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import resetctions from "../../redux/auth/actions";
import Button from "../utils/Button";
import CardLayout from "../utils/CardLayout";
import ToastAlert from "../utils/ToastAlert";
import Modal from "../utils/Modal";

const { resetPassword, resetMessage } = resetctions;

const ResetPassword = ({ showResetModal, onCloseModal }) => {
    const dispatch = useDispatch();
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const { resetPasswordLoading, resetPasswordMessage, resetPasswordError, } = useSelector((state) => state.auth);

    const { register, handleSubmit, watch, reset, formState: { errors, isValid }, } = useForm({
        mode: "onChange",
    });

    const watchNewPassword = watch("newPassword");

    useEffect(() => {
        if (resetPasswordMessage) {
            ToastAlert({ type: "success", text: resetPasswordMessage });
            reset();
        }

        if (resetPasswordError) {
            ToastAlert({ type: "error", text: resetPasswordError });
        }
    }, [resetPasswordMessage, resetPasswordError]);


    const onSubmit = (data) => {
        const payload = {
            oldpass: data.oldPassword.trim(),
            newpass: data.newPassword.trim(),
        };
        dispatch(resetPassword(payload));
    };

    return (
        <Modal
            showModal={showResetModal}
            title="Reset Password"
            width={500}
            showFooter={false}
            onHide={() => { reset(); onCloseModal() }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">
                            Old Password
                        </label>
                        <div className="input-group">
                            <input
                                type={showOldPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter Old Password"
                                {...register("oldPassword", {
                                    required: "Old Password is required",
                                })}
                            />
                            <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowOldPassword(!showOldPassword)}>
                                <i className={showOldPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                            </span>
                            {errors.oldPassword && (<div className="invalid-feedback d-block"> {errors.oldPassword.message} </div>)}
                        </div>
                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">
                            New Password
                        </label>
                        <div className="input-group">
                            <input
                                type={showNewPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter New Password"
                                {...register("newPassword", {
                                    required: "New Password is required",
                                    minLength: {
                                        value: 8,
                                        message: "Minimum 8 characters required",
                                    },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/,
                                        message: "Invalid password format (Example@123)",
                                    },
                                    validate: (value) =>
                                        value !== watch("oldPassword") || "new Password cannot be same as old Password",
                                })}
                            />
                            <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowNewPassword(!showNewPassword)}>
                                <i className={showNewPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                            </span>
                        </div>
                        {errors.newPassword && (<div className="invalid-feedback d-block"> {errors.newPassword.message} </div>)}

                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">
                            Confirm Password
                        </label>
                        <div className="input-group">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter Confirm Password"
                                {...register("confirmPassword", {
                                    required: "Confirm Password is required",
                                    validate: (value) => value === watchNewPassword || "Passwords do not match",
                                })}
                            />
                            <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                <i className={showConfirmPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                            </span>
                        </div>
                        {errors.confirmPassword && (<div className="invalid-feedback d-block"> {errors.confirmPassword.message} </div>)}

                    </div>
                    <div className="col-md-12 mt-2 d-flex justify-content-end">

                        <Button
                            title="Update Password"
                            buttonType="submit"
                            variant="primary"
                            loading={resetPasswordLoading}
                            disable={resetPasswordLoading}
                            icon={<i className="ri-rotate-lock-line fs-5 me-1"></i>}
                        />

                    </div>
                </div>

            </form>
        </Modal>
    );
};

export default ResetPassword;